module.exports = __webpack_public_path__ + "img/logo_user.7206d5d5.png";